import React from 'react';
import {AppBar, Box, CssBaseline, Menu, MenuItem, IconButton, Button,Toolbar,Dialog,
DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { Outlet, useNavigate,  Link } from 'react-router-dom';
import LockResetIcon from '@mui/icons-material/LockReset';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import newLogo from '../images/rcor_logo.png'
import FlexBetween from './FlexBetween';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme'
import NoteAltTwoToneIcon from '@mui/icons-material/NoteAltTwoTone';
import CalculateTwoToneIcon from '@mui/icons-material/CalculateTwoTone';
import FindInPageTwoToneIcon from '@mui/icons-material/FindInPageTwoTone';
import DvrTwoToneIcon from '@mui/icons-material/DvrTwoTone';
import FilePresentTwoToneIcon from '@mui/icons-material/FilePresentTwoTone';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone';
import HomeIcon from '@mui/icons-material/Home';
import CardTravelIcon from '@mui/icons-material/CardTravel';
// import Divider from '@mui/material/Divider';

const drawerWidth = 210;

function DrawerMenu() {
    const navigate = useNavigate()


    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
        handleCloseMenu()
    };
    const handleClose = () => {
        setOpen(false);
        handleCloseMenu()
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex'}}>
                <CssBaseline />
                <AppBar component="nav" position="fixed" sx={{width: '100%', ml: { sm: `${drawerWidth}px` }, backgroundColor: '#404040', height: '55px',}}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <FlexBetween>
                            <IconButton sx={{ mb:'10px', mr: '5px' }} 
                                size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/home')} color="inherit">
                                <HomeIcon sx={{fontSize: "25px" }}  />
                            </IconButton>
                            <Link to='https://www.rcor.co/'><img src={newLogo} alt='logo' /></Link>
                        </FlexBetween>
                        <Toolbar>
                            <Box>
                                <IconButton 
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/enquiry')} color="inherit">
                                    <NoteAltTwoToneIcon sx={{fontSize: "20px", mr: '5px', color:'#66bb6a' }}/>
                                    <span style={{ fontSize: '14px' }}> Enquiry </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/estimate')} color="inherit">
                                    <CalculateTwoToneIcon sx={{fontSize: "20px", mr: '5px', color:'#66bb6a' }} />
                                    <span style={{ fontSize: '14px' }}> Estimate </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/service_Order')} color="inherit">
                                    <BuildTwoToneIcon sx={{ fontSize: "20px",mr: '5px', color:'#66bb6a' }} />
                                    <span style={{ fontSize: '14px' }}> Service </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/Invoice')} color="inherit">
                                    <FindInPageTwoToneIcon sx={{ fontSize: "20px",mr: '5px', color:'#66bb6a' }} />
                                    <span style={{ fontSize: '14px' }}> Invoice </span>
                                </IconButton>                                
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('Cash_Job')} color="inherit">
                                    <CardTravelIcon sx={{ fontSize: "20px",mr: '5px', color:'#66bb6a' }} />
                                    <span style={{ fontSize: '14px' }}> Cash Job </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/Dashboard')} color="inherit">
                                    <DvrTwoToneIcon sx={{ fontSize: "20px", mr: '5px' , color:'#66bb6a'}} />
                                <span style={{ fontSize: '14px' }}> Dashboard </span>
                                    </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/Master')} color="inherit">
                                    <FilePresentTwoToneIcon sx={{fontSize: "20px", mr: '5px', color:'#66bb6a' }} />
                                    <span style={{ fontSize: '14px' }}> Master File </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/Report')} color="inherit">
                                    <DescriptionTwoToneIcon sx={{fontSize: "20px", mr: '5px', color:'#66bb6a'}} />
                                    <span style={{ fontSize: '14px' }}> Report </span>
                                </IconButton>
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/Settings')} color="inherit">
                                    <SettingsTwoToneIcon sx={{fontSize: "20px", mr: '5px', color:'#66bb6a'}} />
                                    <span style={{ fontSize: '14px' }}> Settings </span>
                                </IconButton>
                                {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} color="inherit">
                                    <AccountCircle sx={{ fontSize: "20px",mr: '5px' }} />
                                    <span style={{ fontSize: '14px' }}> User </span>
                                </IconButton>
                                {/* <IconButton
                                size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/MobileNavigation')} color="inherit"> 
                                </IconButton> */}
                              
                            </Box>
                        </Toolbar>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem key='password' onClick={handleClickOpen} sx={{ fontSize: '14px' }}><LockResetIcon sx={{ mr: '10px', fontSize: '18px' }} /> Change Password</MenuItem>
                            <MenuItem key='logout' onClick={()=> navigate('/')} sx={{ fontSize: '14px' }}><PowerSettingsNewIcon sx={{ mr: '10px', fontSize: '18px' }} /> Logout</MenuItem>

                        </Menu>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '15px', textAlign: 'center' }}>
                                Reset Password
                            </DialogTitle>
                            <DialogContent>
                                {/* <ChangePassword handleClose={handleClose} /> */}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose}>Close</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </AppBar>

                
                <Box component="main" sx={{ flexGrow: 1, p: 3, width: `calc(100% - ${drawerWidth}px)`, mt: '40px' }}>
                    <Outlet />
                </Box>
            </Box>
        </ThemeProvider>
    );
}


export default DrawerMenu;